import * as React from "react";

export default function EmailConfigBrandItem(props) {
  const brand = props.brandIdentityCode;

  return (
    <div
      className={`email-config-brand-item ${
        props.brandIdentityCode === props.selectedBrand ? "selected-email-config-brand-item" : ""
      }`}
      onClick={() => {
        if (props.brandIdentityCode === props.selectedBrand) {
          props.addSelectedBrandItem("");
        } else {
          props.addSelectedBrandItem(brand);
        }
      }}
    >
      <div className="email-config-brand-item-image">
        <div className="image-wrapper">
          <img alt={props.brandName} src={props.mainImageUrl} />
        </div>
      </div>
      <div className="email-config-brand-item-plus-button">
        <img alt="plus-btn" src="./assets/plus_button.png" />
      </div>
    </div>
  );
}
